import React, { useState } from 'react'
import { Card, CardBody, CustomInput } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell, faBellSlash } from '@fortawesome/free-solid-svg-icons'
import Flex from '../../common/Flex'
import { updateRewardsNotificationSettings } from '../../../helpers/api/rewards'
import { Toast } from '../../UI/toast/Toast'
import { useRewardsNotificationSettings } from '../useRewardsNotifications'

// HO-TASK-290: el propietario puede silenciar los avisos de Homelan Rewards
// (campana, celebraciones y el badge de Coins) sin dejar de recibir los de su
// condominio. La preferencia la guarda el backend en la wallet de la unidad
// activa (PUT /rewards/notifications/settings), así que se mantiene en
// cualquier dispositivo.
const NotificationSettingsCard = () => {
  const { enabled, loaded, error, mutate } = useRewardsNotificationSettings()
  const [saving, setSaving] = useState(false)

  // Si no se puede leer la preferencia no se muestra un interruptor que
  // podría mentir sobre el estado real.
  if (error || !loaded) return null

  const toggle = async ({ target }) => {
    const next = target.checked
    setSaving(true)
    mutate({ data: { notifications_enabled: next } }, false)
    try {
      const response = await updateRewardsNotificationSettings(next)
      mutate(response, false)
      Toast.fire({
        type: 'success',
        title: next ? 'Volverás a recibir los avisos de Homelan Rewards.' : 'Silenciaste los avisos de Homelan Rewards.'
      })
    } catch (updateError) {
      mutate({ data: { notifications_enabled: !next } }, false)
      Toast.fire({ type: 'error', title: 'No pudimos guardar tu preferencia. Intenta de nuevo.' })
    } finally {
      setSaving(false)
    }
  }

  return (
    <Card className="mb-3">
      <CardBody>
        <Flex align="center" justify="between" className="flex-wrap">
          <Flex align="center" className="mr-3 mb-2 mb-sm-0" style={{ minWidth: 0 }}>
            <FontAwesomeIcon icon={enabled ? faBell : faBellSlash} className={`fs-1 mr-3 ${enabled ? 'text-primary' : 'text-500'}`} />
            <div>
              <h6 className="mb-1">Avisos de Homelan Rewards</h6>
              <p className="fs--1 text-600 mb-0">
                Coins ganadas, subidas de nivel y tu racha. Los avisos de tu condominio no cambian.
              </p>
            </div>
          </Flex>
          <CustomInput
            type="switch"
            id="rewards-notifications-enabled"
            label={enabled ? 'Activados' : 'Silenciados'}
            checked={enabled}
            disabled={saving}
            onChange={toggle}
          />
        </Flex>
      </CardBody>
    </Card>
  )
}

export default NotificationSettingsCard
